import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export const reviewSummaryDefaults = {
  overallRating: 0,
  reviewCount: 0
};
export default class ReviewSummary extends createImmutableObjectClass(reviewSummaryDefaults) {}